// Route-aware smooth scrolling. Hash links work from any page: on the homepage
// they scroll; on sub-pages they navigate home first and HomePage finishes the scroll.
export const scrollToId = (href) => {
  if (window.location.pathname !== "/" && window.__navigate) {
    window.__navigate("/" + href);
    return;
  }
  if (href === "#top") {
    window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.2 }) : window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToTopNow = () => {
  if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  window.scrollTo(0, 0);
};
